import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

 var product = new Swiper('.section1 .mySwiper', {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: '1.21%',
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: '1.21%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '1.21%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      }
    },
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",              
    },
});
var swiper = new Swiper(".section3 .mySwiper", {
    pagination: {
        el: ".section3 .swiper-pagination",
        clickable: true,
    },
});
